/**
 * Import files and plugins here
 */
import "babel-polyfill"
import "@babel/polyfill"

/* Polyfills */

import "mdn-polyfills/Node.prototype.prepend"
import "mdn-polyfills/Element.prototype.closest"
import "mdn-polyfills/NodeList.prototype.forEach"

import Vue from "vue"
import App from "./App.vue"
import { routes } from "./router/routes"
import VueRouter from "vue-router"
import { store } from "./store"

// import "es6-promise/auto"
import i18n from "./i18n"
import middleware from "./router/middleware"
import Fragment from "vue-fragment"
import Vuesax from "vuesax"
// import "./registerServiceWorker"
import { vsButton, vsSelect, vsPopup } from "vuesax"
import vClickOutside from "v-click-outside"
import Vue2TouchEvents from "vue2-touch-events"
import Vuebar from "vuebar"
import ScrollSync from "vue-scroll-sync"
import VTooltip from "v-tooltip"
import VueGoodTablePlugin from "vue-good-table"
import GeminiScrollbar from "vue-gemini-scrollbar"

// import './service-worker';
//vendor styles
import "material-icons/iconfont/material-icons.css"
import "vuesax/dist/vuesax.css"
import "vue-good-table/dist/vue-good-table.css"
import axiosConfig from "./config/axiosConfig"
import vSelect from "vue-select"

Vue.config.productionTip = false
Vue.config.performance = true

/**
 * Use services here
 */
Vue.use(VueRouter)
Vue.use(Fragment.Plugin)
Vue.use(Vuesax)
Vue.use(vsButton)
Vue.use(vsSelect)
Vue.use(vsPopup)
Vue.use(vClickOutside)
Vue.use(Vue2TouchEvents)
Vue.use(Vuebar)
Vue.use(VTooltip)
Vue.use(VueGoodTablePlugin)

Vue.component("scroll-sync", ScrollSync)
Vue.component("v-select", vSelect)
Vue.use(GeminiScrollbar)
// require("es6-promise").polyfill()
/**
 * Service config.
 * @type {VueRouter}
 */
// set routing config.
export const router = new VueRouter({
    mode: "history",
    routes: routes,
    // scroll behaviour on every route navigations.
    scrollBehavior() {
        // scroll to top
        return { x: 0, y: 0 }
    }
})
// add middleware to routing
middleware(router)
axiosConfig()
console.log(process.env.NODE_ENV)
/**
 * Start vue instance
 */
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app")

//google-chrome --disable-web-security --user-data-dir=~/chromeTemp
